export const awsconfig = {
  Auth: {
    Cognito: {
      region: import.meta.env.VITE_REGION,
      userPoolId: import.meta.env.VITE_COGNITO_USERPOOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_USERPOOL_CLIENTID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN,
          scopes: [
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin'
          ],
          redirectSignIn: [import.meta.env.VITE_CALLBACK_URL],
          redirectSignOut: [import.meta.env.VITE_CALLBACK_URL],
          responseType: 'code'
        }
      }
    }
  }
};
